import api from '../lib/api';
import { JobTitle } from '../types';

export const jobTitlesApi = {
  list: () =>
    api.get<JobTitle[]>('/api/v1/job-titles'),
  create: (body: { name: string; costRate?: number; revenueRate?: number }) =>
    api.post<JobTitle>('/api/v1/job-titles', body),
  update: (id: string, body: { name?: string; costRate?: number; revenueRate?: number }) =>
    api.patch<JobTitle>(`/api/v1/job-titles/${id}`, body),
  delete: (id: string) =>
    api.delete(`/api/v1/job-titles/${id}`),
};
